import axios from 'axios'
// 序列化/反序列化参数 将对象转换为字符串 a:1,b:2 => a=1&b=2
import qs from 'qs'

// 错误提示组件  IView (View UI, View Design)
import { Notice } from "view-ui-plus";

const service = axios.create({
	// 服务器地址
	baseURL: 'http://www.duzhaojiang.cn:9999/studyrooms/api',
	// 本地地址
	// baseURL: 'http://localhost:9999/studyrooms/api',
	timeout: 15000 
})
// request拦截器
service.interceptors.request.use(config => {
	if(config.method === "post"){
		// 序列化参数
		config.data = qs.stringify(config.data,  { indices: false });
	}
	return config;
}, error => {
	// 处理请求错误 抛出错误信息
	Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
	success => {
		if (success.data.code == 0) {
			return success.data;
		}else if (success.data.code == 1){
			return success.data;
		} else {
			// 错误提示组件 
			Notice.error({
				duration: 3, // 持续时间
				title: success.data.msg // 标题
			});
			return Promise.reject(success.data);
		}
	},
	error => {
		Notice.error({
			duration: 3,
			title: '系统异常，请求中断'
		});
		return Promise.reject(error);
	}
)

export default service